<!--
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
-->

<template>
  <svg
    width="183px"
    height="183px"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    class="lds-ripple"
    style="background: none;"
  >
    <circle
      cx="50"
      cy="50"
      r="38.1863"
      fill="none"
      stroke="#245572"
      stroke-width="2"
    >
      <animate
        attributeName="r"
        calcMode="spline"
        values="0;45"
        keyTimes="0;1"
        dur="2.1"
        keySplines="0 0.2 0.8 1"
        begin="-1.05s"
        repeatCount="indefinite"
      />
      <animate
        attributeName="opacity"
        calcMode="spline"
        values="1;0"
        keyTimes="0;1"
        dur="2.1"
        keySplines="0.2 0 0.8 1"
        begin="-1.05s"
        repeatCount="indefinite"
      />
    </circle>
    <circle
      cx="50"
      cy="50"
      r="16.4418"
      fill="none"
      stroke="#245572"
      stroke-width="2"
    >
      <animate
        attributeName="r"
        calcMode="spline"
        values="0;45"
        keyTimes="0;1"
        dur="2.1"
        keySplines="0 0.2 0.8 1"
        begin="0s"
        repeatCount="indefinite"
      />
      <animate
        attributeName="opacity"
        calcMode="spline"
        values="1;0"
        keyTimes="0;1"
        dur="2.1"
        keySplines="0.2 0 0.8 1"
        begin="0s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
</template>

<script>
export default {};
</script>

<style scoped>
</style>
